import { YEAR_MS } from '@dr.pogodin/js-utils';
import type { UseAsyncDataResT } from '@dr.pogodin/react-utils';

import { getGallery } from 'services';
import { type ImageAssetT, useAsyncCollection } from 'utils';

type UseGalleryResT = UseAsyncDataResT<ImageAssetT[]>;

export function useGallery(artistId: string): UseGalleryResT {
  const gallery = useAsyncCollection(
    artistId,
    'artistGalleries',
    async (id) => (id ? getGallery(id) : Promise.resolve([])),
    { maxage: YEAR_MS },
  );

  return gallery;
}
